export default __webpack_public_path__ + "static/media/aerodrome.df3bfb29.svg";